import React from 'react'

export default function Error404(): JSX.Element {
    // Criar uma página de 404 com um botão voltar
    return <div>Error404</div>
}
